export const PROPOSTAS_DESIGN = {
    page: {
        container: 'h-full overflow-y-auto',
        content: 'max-w-[98%] mx-auto',
        iconBox: 'p-2 bg-[#7C3AED]/10 rounded-lg',
        icon: 'text-[#7C3AED]',
        title: 'text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]',
        // Sem `shadow-*` aqui: o <Button> já traz o relevo 3D (luz na aresta de cima +
        // espessura na base + sombra externa) na variante default. Uma sombra passada
        // via className vence a do rest-state no tailwind-merge, mas não a de hover —
        // era por isso que o relevo só aparecia ao passar o mouse.
        actionButton: 'h-9 bg-[#7C3AED] hover:bg-[#6D28D9] text-white font-medium rounded-lg px-4 text-xs'
    },
    stats: {
        grid: 'grid grid-cols-2 md:grid-cols-4 gap-3 mb-4',
        card: 'bg-white dark:bg-[#222529] rounded-xl border border-gray-100 dark:border-[#383838] p-4 flex items-center gap-3',
        iconBox: 'w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50 dark:bg-violet-500/10',
        icon: 'text-violet-600 dark:text-violet-400',
        value: 'text-xl font-bold text-gray-900 dark:text-[#D1D2D3]',
        label: 'text-xs text-gray-500 dark:text-[#ABABAD]'
    },
    status: {
        rascunho: { label: 'Rascunho', bg: 'bg-gray-100 dark:bg-gray-500/10', text: 'text-gray-600 dark:text-gray-400', dot: 'bg-gray-400' },
        enviada: { label: 'Enviada', bg: 'bg-blue-50 dark:bg-blue-500/10', text: 'text-blue-700 dark:text-blue-400', dot: 'bg-blue-500' },
        visualizada: { label: 'Visualizada', bg: 'bg-amber-50 dark:bg-amber-500/10', text: 'text-amber-700 dark:text-amber-400', dot: 'bg-amber-500' },
        aceita: { label: 'Aceita', bg: 'bg-green-50 dark:bg-green-500/10', text: 'text-green-700 dark:text-green-400', dot: 'bg-green-500' },
        recusada: { label: 'Recusada', bg: 'bg-red-50 dark:bg-red-500/10', text: 'text-red-700 dark:text-red-400', dot: 'bg-red-500' },
        expirada: { label: 'Expirada', bg: 'bg-orange-50 dark:bg-orange-500/10', text: 'text-orange-700 dark:text-orange-400', dot: 'bg-orange-500' },
        cancelada: { label: 'Cancelada', bg: 'bg-gray-100 dark:bg-gray-500/10', text: 'text-gray-500 dark:text-gray-500', dot: 'bg-gray-400' }
    },
    // Mesmo sistema visual do kanban de conversas arquivadas
    // (sections/@chats/arquivadas/ChatsArquivadas.design.js): coluna cinza sem
    // borda, cards compactos com avatar + linha de apoio + rodapé separado.
    kanban: {
        // Colunas elásticas: com poucos estágios elas ocupam a largura toda e o
        // board não precisa de scroll horizontal; a partir de ~7 o min-w volta a
        // empurrar o overflow-x.
        board: 'flex flex-row gap-2 overflow-x-auto pb-2 items-start',
        column: 'flex flex-col flex-1 min-w-[190px] max-w-[280px] bg-gray-200/45 dark:bg-[#1A1D21] rounded-2xl h-fit max-h-[calc(100vh-260px)]',
        columnHeader: 'flex items-center gap-1.5 px-3 pt-2.5 pb-1.5',
        columnIconBox: 'w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0',
        columnTitle: 'text-xs font-semibold text-gray-900 dark:text-[#D1D2D3] truncate',
        columnCount: 'ml-auto text-[11px] font-medium text-gray-400 tabular-nums flex-shrink-0',
        columnTotal: 'px-3 pb-1.5 -mt-0.5 pl-[26px] text-[10px] font-medium text-gray-400 tabular-nums',
        columnBody: 'flex-1 overflow-y-auto px-1.5 pb-1.5 space-y-1.5 min-h-[100px]',
        columnBodyDragging: 'bg-violet-100/50 dark:bg-violet-500/10 rounded-xl',
        columnEmpty: 'flex flex-col items-center justify-center py-8 text-center',
        columnEmptyText: 'text-[11px] text-gray-400 dark:text-gray-600'
    },
    kanbanCard: {
        container:
            'bg-white dark:bg-[#222529] rounded-lg border border-gray-200/60 dark:border-[#383838] p-2 shadow-[0_1px_2px_rgba(16,24,40,0.06)] hover:shadow-[0_4px_10px_rgba(16,24,40,0.1)] hover:-translate-y-px transition-all duration-200 cursor-pointer group',
        containerDragging: 'opacity-40 ring-2 ring-[#7C3AED]/30',
        header: 'flex items-start gap-1.5',
        avatar: 'w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-bold text-white flex-shrink-0',
        title: 'text-xs font-semibold text-gray-900 dark:text-[#D1D2D3] truncate',
        subtitle: 'text-[10px] leading-tight text-gray-500 dark:text-[#ABABAD] line-clamp-1 mt-0.5 flex items-center gap-1',
        action:
            'w-5 h-5 rounded-md text-gray-300 hover:bg-gray-100 dark:hover:bg-[#383838] hover:text-[#7C3AED] flex items-center justify-center transition-all opacity-0 group-hover:opacity-100 flex-shrink-0',
        footer: 'flex items-center justify-between gap-1.5 mt-1.5 pt-1 border-t border-gray-100 dark:border-[#383838]/60',
        meta: 'flex items-center gap-1.5 min-w-0',
        date: 'text-[9px] text-gray-400 tabular-nums flex-shrink-0',
        views: 'text-[9px] text-gray-400 flex items-center gap-0.5 flex-shrink-0',
        value: 'flex items-center px-1 py-0.5 rounded bg-green-50 dark:bg-green-500/10 text-[9px] font-semibold text-green-700 dark:text-green-400 tabular-nums flex-shrink-0'
    },
    // Acompanhamento do acesso do cliente ao link público (visitas, tempo,
    // downloads, assinatura). Mesmos tokens no drawer da lista/kanban e na
    // sidebar do editor.
    acompanhamento: {
        wrapper: 'space-y-4',
        statsGrid: 'grid grid-cols-2 gap-2',
        statCard: 'bg-white dark:bg-[#222529] rounded-xl border border-gray-100 dark:border-[#383838] p-3',
        statValue: 'text-lg font-bold text-gray-900 dark:text-[#D1D2D3] tabular-nums leading-tight',
        statLabel: 'text-[10px] text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mt-0.5',
        sectionLabel: 'text-[10px] font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-2 block',
        timeline: 'space-y-2',
        evento: 'flex items-start gap-2.5',
        eventoIcone: 'w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0',
        eventoTitulo: 'text-xs font-medium text-gray-900 dark:text-[#D1D2D3]',
        eventoMeta: 'text-[10px] text-gray-500 dark:text-[#ABABAD] leading-relaxed',
        vazio: 'flex flex-col items-center justify-center py-8 text-center',
        vazioTexto: 'text-[11px] text-gray-400 dark:text-gray-500 mt-1.5'
    },
    assinatura: {
        card: 'bg-white dark:bg-[#222529] rounded-xl border border-green-100 dark:border-green-500/20 p-4',
        header: 'flex items-center gap-2 mb-3',
        headerIcon: 'w-7 h-7 rounded-lg bg-green-50 dark:bg-green-500/10 flex items-center justify-center text-green-600 dark:text-green-400 flex-shrink-0',
        headerTitle: 'text-xs font-bold text-gray-900 dark:text-[#D1D2D3]',
        headerSub: 'text-[10px] text-gray-500 dark:text-[#ABABAD]',
        imagemBox: 'bg-gray-50 dark:bg-[#1A1D21] rounded-lg border border-gray-100 dark:border-[#383838] p-2 flex items-center justify-center',
        imagem: 'max-h-24 object-contain',
        linha: 'flex items-start justify-between gap-3 py-1',
        linhaLabel: 'text-[10px] text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider flex-shrink-0',
        linhaValor: 'text-[11px] text-gray-900 dark:text-[#D1D2D3] text-right break-all',
        hash: 'text-[10px] font-mono text-gray-500 dark:text-[#ABABAD] break-all bg-gray-50 dark:bg-[#1A1D21] rounded-lg px-2 py-1.5',
        download: 'w-full flex items-center justify-center gap-1.5 mt-3 px-3 py-2 text-xs font-medium text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 rounded-lg border border-violet-200 dark:border-violet-500/30 transition-colors'
    },
    editor: {
        page: 'h-full flex flex-col bg-gray-50 dark:bg-[#1A1D21]',
        topbar: 'sticky top-0 z-30 flex items-center justify-between gap-4 px-5 py-3 bg-white dark:bg-[#222529] border-b border-gray-100 dark:border-[#383838]',
        topbarLeft: 'flex items-center gap-3',
        backButton: 'p-2 rounded-lg text-gray-400 hover:text-gray-700 dark:hover:text-[#D1D2D3] hover:bg-gray-100 dark:hover:bg-[#383838] transition-colors',
        title: 'text-lg font-bold text-gray-900 dark:text-[#D1D2D3]',
        badge: 'text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-md bg-violet-50 text-[#7C3AED] dark:bg-violet-500/10',
        canvasWrapper: 'flex-1 overflow-y-auto py-8 px-4',
        canvas: 'max-w-[794px] mx-auto bg-white dark:bg-[#26292d] shadow-lg rounded-sm min-h-[1000px] p-12',
        blockHover: 'group relative rounded-lg transition-colors hover:bg-violet-50/40 dark:hover:bg-violet-500/5 -mx-3 px-3 py-2'
    }
};

// Avatar do card: cor estável derivada do texto (mesmo título, mesma cor).
const AVATAR_COLORS = ['#7C3AED', '#2563EB', '#059669', '#D97706', '#DC2626', '#0891B2', '#DB2777'];

export const getCorAvatar = (nome) => {
    if (!nome) return AVATAR_COLORS[0];
    let hash = 0;
    for (let i = 0; i < nome.length; i += 1) hash = nome.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

export const getIniciais = (nome) => {
    if (!nome) return '?';
    return nome.trim().split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase();
};
